/*公共js方法*/
var common = {}

common.install = (Vue,option)=>{
    // 检测是否有未支付订单
	Vue.prototype.checkOrderPayStatus = function(params){
        return new Promise((resolve,reject)=>{
            this.$axios.post('/acInstallerInsurance/queryUnpaidOrder.all',params).then(res=>{
                if(res.code==10000000){
                    resolve(res)
                }else{
                    this.confirm('您有尚未付款的订单,请去订单列表支付或取消订单后,再进行此操作。',()=>{
                        this.$router.push('/my/order?status=1')
                    },{
                        okText:'我的订单',
                        cancelText:'关闭'
                    })
                    reject(res.msg)
                }
            })
        })
    },
    // 检测是否有拒保订单
	Vue.prototype.checkOrderRefuseStatus = function(params){
        return this.$axios.post('/insurance2b/insurance/queryPushFailedOrder.json',params)
    }
}
export default common


// WEBPACK FOOTER //
// ./src/pages/haierProduct/common/index.js